/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesPerformance {
	FEEDBACK_AVERAGE = "res://senior.com.br/analytics/hcm/performance/manager/feedbackAverage", //ok
	FEEDBACK_REQUESTS = "res://senior.com.br/analytics/hcm/performance/feedbackLastTwelveMonthsChart",
	LED_GOALS_COUNT_BY_STATE = "res://senior.com.br/analytics/hcm/performance/manager/ledGoalsCountByState",//ok
	COMPETENCE_EVALUATION = "res://senior.com.br/analytics/hcm/performance/manager/performanceAppraisalOverallResult",//ok
	COMPETENCE_EVALUATION_RESULTS = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalOverallResult",//ok
	COMPETENCE_EVALUATION_BY_COMPETENCE = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalByCompetency",//ok
	COMPETENCE_APPRAISAL = "res://senior.com.br/analytics/hcm/performance/manager/individualCompetenciesAppraisalResult",//ok
	COMPETENCE_EVALUATION_SITUATION = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalSituationChart",//ok
	MY_COMPETENCY_MAP = "res://senior.com.br/analytics/hcm/career/myCompetenceMap",//ok
	PERFORMANCE_APPRAISAL = "res://senior.com.br/analytcis/hcm/performance/manager/performanceAppraisalSituationByCycle",
	PERFORMANCE_COMPETENCE_ACHIEVEMENT_RESULT_BY_CICLE = "res://senior.com.br/analytics/hcm/performance/employee/performanceCompetenceAchievementResultByCycle",//ok
	PROFICIENCY_LEVEL = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalCountByProficiencyLevel",//ok
	SUBORDINATES_FEEDBACKS = "res://senior.com.br/analytics/hcm/career/manager/subordinatesFeedbacks",//ok
	MAP_OF_COMPETENCES = "res://senior.com.br/analytics/hcm/career/manager/employeeCompetenciesGap",//ok
	EVOLUTION_PERFORMANCE_LEVEL = "res://senior.com.br/analytics/hcm/career/employee/developmentEvolutionLevel",//ok
	PERFORMANCE_APPRAISAL_RESULT = "res://senior.com.br/analytics/hcm/performance/employee/performanceAppraisalAchievementResultByCycle",//ok
	RECEIVED_FEEDBACKS = "res://senior.com.br/analytics/hcm/career/manager/receivedFeedbacks",//ok
	INDIVIDUAL_DEVELOPMENT_PLAN = "res://senior.com.br/analytics/hcm/performance/employee/goalsCountByState",
	MANAGER_PENDING_EVALUATION_SUMMARY = "res://senior.com.br/analytics/hcm/career/manager/pendingEvaluation",
	EMPLOYEE_PENDING_EVALUATION_SUMMARY = "res://senior.com.br/analytics/hcm/employee/pendingEvaluationSummary"
}

/**
 * Cards da página Manager, aba Performance
 */
export enum PermissionResourcesPerformanceManager {
	FEEDBACK_AVERAGE = "res://senior.com.br/analytics/hcm/performance/manager/feedbackAverage",
	COMPETENCE_EVALUATION_RESULTS = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalOverallResult",
	COMPETENCE_EVALUATION_SITUATION = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalSituationChart",
	COMPETENCE_EVALUATION_BY_COMPETENCE = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalByCompetency",
	PROFICIENCY_LEVEL = "res://senior.com.br/analytics/hcm/performance/manager/competenciesAppraisalCountByProficiencyLevel",
	COMPETENCE_EVALUATION = "res://senior.com.br/analytics/hcm/performance/manager/performanceAppraisalOverallResult",
	PERFORMANCE_APPRAISAL = "res://senior.com.br/analytcis/hcm/performance/manager/performanceAppraisalSituationByCycle",
	LED_GOALS_COUNT_BY_STATE = "res://senior.com.br/analytics/hcm/performance/manager/ledGoalsCountByState",
	MANAGER_PENDING_EVALUATION_SUMMARY = "res://senior.com.br/analytics/hcm/career/manager/pendingEvaluation"
}

/**
 * Cards da página My, aba Performance
 */
export enum PermissionResourcesPerformanceMy {
	RECEIVED_FEEDBACKS = "res://senior.com.br/analytics/hcm/career/manager/receivedFeedbacks",
	PERFORMANCE_COMPETENCE_ACHIEVEMENT_RESULT_BY_CICLE = "res://senior.com.br/analytics/hcm/performance/employee/performanceCompetenceAchievementResultByCycle",
	MY_COMPETENCY_MAP = "res://senior.com.br/analytics/hcm/career/myCompetenceMap",
	PERFORMANCE_APPRAISAL_RESULT = "res://senior.com.br/analytics/hcm/performance/employee/performanceAppraisalAchievementResultByCycle",
	INDIVIDUAL_DEVELOPMENT_PLAN = "res://senior.com.br/analytics/hcm/performance/employee/goalsCountByState",
	EMPLOYEE_PENDING_EVALUATION_SUMMARY = "res://senior.com.br/analytics/hcm/employee/pendingEvaluationSummary"
}

/**
 * Cards da página Led, aba Performance
 */
export enum PermissionResourcesPerformanceLed {
	COMPETENCE_APPRAISAL = "res://senior.com.br/analytics/hcm/performance/manager/individualCompetenciesAppraisalResult",
	MAP_OF_COMPETENCES = "res://senior.com.br/analytics/hcm/career/manager/employeeCompetenciesGap",
	LED_GOALS_COUNT_BY_STATE = "res://senior.com.br/analytics/hcm/performance/manager/ledGoalsCountByState",
	EVOLUTION_PERFORMANCE_LEVEL = "res://senior.com.br/analytics/hcm/career/employee/developmentEvolutionLevel",
	SUBORDINATES_FEEDBACKS = "res://senior.com.br/analytics/hcm/career/manager/subordinatesFeedbacks"
}
